import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../../store/hooks";
import { useViewport } from "../../../hooks/useViewport";
import { FiscalIssuesReport } from "./FiscalIssuesReport";

// „Фискални проблеми" като самостоятелна страница на модул „Мониторинг".
// Достъпна е САМО за администратора (user id = 1) — както /audit-log.
const FiscalIssuesPage = () => {
  const userId = useAppSelector((s) => s.auth.userId);
  const status = useAppSelector((s) => s.auth.status);
  const { isNarrow } = useViewport();

  if (status === "loading") return null;
  if (userId !== 1) return <Navigate to="/" replace />;

  // Компонентът е писан за layout-а на Справките (родител с h-screen) —
  // коренът му е h-full, затова тук му даваме цял екран и фон, иначе под
  // съдържанието остава бяло.
  return (
    <div className="h-screen overflow-y-auto bg-canvas">
      <FiscalIssuesReport isNarrow={isNarrow} />
    </div>
  );
};

export default FiscalIssuesPage;
